export default "__VITE_ASSET__df7b7e1a__"